module.exports = __webpack_public_path__ + "/images/cover-cta-hamaca-babybjorn-m.3076b6f.png";